<template>
  <div class="form-control relative">
    <label class="block" :class="[themes_labes[theme]]" v-if="label">
      <span v-html="label"></span>
      <span v-if="required" class="obligatoire">*</span>
    </label>
    <list-select
      :list="countries"
      option-value="value"
      option-text="name"
      :placeholder="placeholder"
      :selected-item="item"
      @select="onSelect"
      name="countries"
      id="countries" 
      class="mb-5"      
      autocomplete="new-password"    
    ></list-select>
  </div>
</template>

<style>
.ui.selection.dropdown {
    border: 1px solid #7d8593 !important;
    border-radius: 5px !important;
    color: #313232 !important;
}
.ui.fluid.dropdown > .dropdown.icon {
    top: 1.3rem !important;
}
.ui.selection.active.dropdown .menu {
    border-color: #7d8593 !important;
}
</style>

<script>
import { ListSelect } from "vue-search-select";

export default {
  name: "sp-select-country",
  components: {
    ListSelect
  },
  props: {
    label: String,
    placeholder: String,
    required: {
      type: Boolean,
      default: false
    },
    theme: {
      required: false,
      type: String,
      default: ""
    },
    monospaced: {
      type: Boolean,
      default: false
    },
    hasError: {
      required: false,
      type: Boolean,
      default: false
    },
    selected: {
      type: String | Array,
      default: null
    }
  },
  data() {
    return {
      themes: {
        default: "",
        form:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        team:
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight",
        "team-i":
          "border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight pl-14"
      },
      themes_labes: {
        default: "mb-4",
        form: "text-blue text-2sm mb-4",
        team: "text-blue text-2sm font-bold mb-3",
        "team-i": "text-blue text-2sm font-bold mb-3"
      },
      countries: [],
      item: {
        value: "",
        name: ""
      }
    };
  },
  beforeMount: function() {
    var list = require("./countries.js");
    for (var i = 0; i < list.length; ++i) {
      var code = list[i].code;
      var name = list[i].name;
      if (this.$i18n && this.$i18n.country && this.$i18n.country[code]) {
        name = this.$i18n.country[code];
      }
      this.countries.push({
        value: code,
        name: name
      });
    }
  },
  mounted() {
    if (this.selected) {
      let op = this.countries.find(this.findValue);
      this.item = op;
      this.toggle();
    }
  },
  methods: {
    findValue(op) {
      if (op.name == this.selected) {
        return op;
      }
    },
    onSelect(item) {
      this.item = item;
      this.toggle();
    },
    // deselect option
    reset() {
      this.item = {}; // reset
    },
    onChange() {
      this.toggle();
    },

    toggle() {
      this.$emit("input", this.item.name);
    }
  },
  watch:{
    selected(){
       if (this.selected) {
          let op = this.countries.find(this.findValue);
          this.item = op;
          this.toggle();
        }
    }
  }
};
</script>
